import { Component } from '@angular/core';
import { Statement } from '../../../businesses/models/statements.models';

import { BehaviorSubject } from 'rxjs';
import { StatementsFacade } from '../../../businesses/services/statements.facade';

@Component({
  standalone: false,
  selector: 'hospitable-statements-commissions-list',
  templateUrl: './statements-commissions-list.component.html',
  styleUrls: ['./statements-commissions-list.component.scss'],
})
export class StatementsCommissionsListComponent {
  commissionsState$ = this.statementsService.commissionState$;
  displayedColumns = ['name', 'properties', 'actions'];
  public deletingAgreement$ = new BehaviorSubject<Statement['id']>(null);

  constructor(private statementsService: StatementsFacade) {
    this.statementsService.getCommissionAgreements();
  }
}
